import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';

import { NDDFormErrorValidatorService } from '../ndd-ng-form-error/shared/ndd-ng-form-error-validator.service';
import { NDDFormErrorService } from '../ndd-ng-form-error/shared/ndd-ng-form-error.service';
import { NDDFormsBaseComponent } from '../shared/ndd-ng-forms.base-component';

/** Componente input. */
@Component({
    selector: 'ndd-ng-form-input',
    template: require('./ndd-ng-form-input.component.html'),
})
export class NDDFormInputComponent extends NDDFormsBaseComponent implements OnInit {
    /** Tipo de input. */
    @Input() public controlType: 'text' | 'email' | 'password' | 'tel' = 'text';

    /** Define se o valor do controle pode ser completado automaticamente pelo navegador. */
    @Input() public controlAutocomplete?: 'off' | 'on' | 'new-password';
    /** Define tamanho máximo de caracteres. */
    @Input() public controlMaxLength?: number;
    /** Define tamanho mínimo de caracteres. */
    @Input() public controlMinLength?: number;
    /** Define pattern para validação. */
    @Input() public controlPattern?: string | RegExp;
    /** Define placeholder para exibição no controle quando valor for vazio. */
    @Input() public controlPlaceholder?: string;
    /** Define controle como somente leitura. */
    @Input() public controlReadonly?: boolean;
    /** Remover espaços antes e depois do valor. */
    @Input() public controlTrim?: boolean;

    @ViewChild('input', { static: false }) private input: ElementRef;

    constructor(formErrorService: NDDFormErrorService, cdr: ChangeDetectorRef) {
        super(formErrorService, cdr);
    }

    public ngOnInit(): void {
        super.addControl();

        // Por atributo

        if (this.controlRequired) {
            super.cacheValidator(NDDFormErrorValidatorService.required(this.controlTrim));
        }

        if (this.controlPattern) {
            super.cacheValidator(Validators.pattern(this.controlPattern));
        }

        if (this.controlMaxLength || this.controlMaxLength === 0) {
            super.cacheValidator(Validators.maxLength(this.controlMaxLength));
        }

        if (this.controlMinLength || this.controlMinLength === 0) {
            super.cacheValidator(Validators.minLength(this.controlMinLength));
        }

        // Por tipo

        if (this.controlType === 'email') {
            super.cacheValidator(NDDFormErrorValidatorService.email);
        }

        super.addValidators();

        this.control.valueChanges.pipe(
            takeUntil(this.ngUnsubscribe))
            .subscribe((value: string) => {
                if (value && this.controlTrim) {
                    value = value.trim();
                }

                this.controlValueChange.emit(value);
            });
    }

    /**
     * Marca o input como `touched` para atualizar as validações.
     *
     * @override
     * @memberof NDDFormInputComponent
     */
    public updateValidity(): void {
        this.trimmer();

        super.updateValidity();
    }

    /**
     * Executa `String.trim()` no valor do input.
     *
     * @memberof NDDFormInputComponent
     */
    public trimmer(): void {
        if (this.control.value && this.controlTrim) {
            const trimmed: string = this.control.value.trim();

            this.control.setValue(trimmed);

            /*
             * Forçar alteração visual do valor
             * pois alguns navegadores não mantém o valor com espaços no início/final (apenas visualmente),
             * gerando inconsistência entre o que o usuário está visualizando e o que de fato está ocorrendo.
             */
            this.input.nativeElement.value = '';
            this.input.nativeElement.value = trimmed;
        }
    }
}
